import { stringIsNullOrEmpty, formatStringForCompare, formatStringForAppTypePlural } from 'app/shared/utils/string.util';

import { isFairfaxEnvironment, isMooncakeEnvironment, isUsNatEnvironment, isUsSecEnvironment, isBleuEnvironment, isDelosEnvironment } from 'environments/environment.util';
import { ISelectOption } from 'app/interfaces/ISelectOption';
import { ExposureControlService } from 'app/services/exposure-control/base-exposure-control.service';
export const regionOnPremises = 'On-Premises';
export const regionUnKnown = 'Unknown';

export const regions = {
    AutoResolve: 'AutoResolve',
    AustraliaEast: 'Australia East',
    AustraliaSoutheast: 'Australia Southeast',
    BrazilSouth: 'Brazil South',
    CanadaCentral: 'Canada Central',
    CanadaEast: 'Canada East',
    CentralIndia: 'Central India',
    CentralUS: 'Central US',
    CentralUSEUAP: 'Central US EUAP',
    EastAsia: 'East Asia',
    EastUS: 'East US',
    EastUS2: 'East US 2',
    EastUS2EUAP: 'East US 2 EUAP',
    FranceCentral: 'France Central',
    GermanyWestCentral: 'Germany West Central',
    JapanEast: 'Japan East',
    JapanWest: 'Japan West',
    JioIndiaWest: 'Jio India West',
    QatarCentral: 'Qatar Central',
    KoreaCentral: 'Korea Central',
    KoreaSouth: 'Korea South',
    NorthCentralUS: 'North Central US',
    NorthEurope: 'North Europe',
    SouthCentralUS: 'South Central US',
    SouthIndia: 'South India',
    SoutheastAsia: 'Southeast Asia',
    SwedenCentral: 'Sweden Central',
    UKSouth: 'UK South',
    UKWest: 'UK West',
    WestCentralUS: 'West Central US',
    WestEurope: 'West Europe',
    WestIndia: 'West India',
    WestUS: 'West US',
    WestUS2: 'West US 2',
    WestUS3: 'West US 3',
    SouthAfricaNorth: 'South Africa North',
    SouthAfricaWest: 'South Africa West',
    SwitzerlandNorth: 'Switzerland North',
    SwitzerlandWest: 'Switzerland West',
    NorwayEast: 'Norway East',
    UAENorth: 'UAE North',
    USGovVirginia: 'usgovvirginia',
    USGovArizona: 'usgovarizona',
    USGovIowa: 'usgoviowa',
    USGovTexas: 'usgovtexas',
    USDoDCentral: 'usdodcentral',
    USDoDEast: 'usdodeast',
    ChinaEast: 'chinaeast',
    ChinaEast2: 'chinaeast2',
    ChinaNorth: 'chinanorth',
    ChinaNorth2: 'chinanorth2',
    ChinaNorth3: 'chinanorth3',
    UsNatEast: 'usnateast',
    UsNatWest: 'usnatwest',
    UsSecEast: 'usseceast',
    UsSecWest: 'ussecwest',
    BleuFranceCentral: 'bleufrancecentral',
    BleuFranceSouth: 'bleufrancesouth',
    DelosCloudGermanyCentral: 'deloscloudgermanycentral',
    DelosCloudGermanyNorth: 'deloscloudgermanynorth'
};

export const euRegions = [
    regions.FranceCentral,
    regions.GermanyWestCentral,
    regions.NorthEurope,
    regions.UKSouth,
    regions.UKWest,
    regions.WestEurope,
    regions.SwitzerlandNorth,
    regions.SwitzerlandWest,
    regions.SwedenCentral,
    regions.NorwayEast,
    regions.BleuFranceCentral,
    regions.BleuFranceSouth,
    regions.DelosCloudGermanyCentral,
    regions.DelosCloudGermanyNorth
];

export function isEURegion(region: string): boolean {
    return euRegions.includes(formatRegionString(region));
}

export const dataFlowUnsupportedRegionsPublic: string[] = [];

export const dataFlowUnsupportedRegionsFairfax = [
    'usgoviowa',
    'usdodcentral',
    'usdodeast'
];

export const dataFlowUnsupportedRegionsMooncake = [
    'chinaeast',
    'chinanorth'
];

export const dataFlowUnsupportedRegionsUsNat = [
    'usnateast',
    'usnatwest'
];

export const dataFlowUnsupportedRegionsUsSec = [
    'usseceast',
    'ussecwest'
];

export function dataFlowUnsupportedMessage(message: string, services: { exposureControlService: ExposureControlService }): string {
    if (isFairfaxEnvironment()) {
        return formatStringForAppTypePlural(message, dataFlowUnsupportedRegionsFairfax.map((region) => localizeRegionString(region)).join(', '));
    }
    if (isMooncakeEnvironment()) {
        return formatStringForAppTypePlural(message, dataFlowUnsupportedRegionsMooncake.map((region) => localizeRegionString(region)).join(', '));
    }
    if (isBleuEnvironment()) {
        return '';  // Assuming Bleu environment has no unsupported regions for data flow
    }
    if (isDelosEnvironment()) {
        return '';  // Assuming Delos environment has no unsupported regions for data flow
    }
    if (__IS_A365__ || services.exposureControlService.enableADFSparkGateway) {
        return '';
    }
    if (isUsNatEnvironment()) {
        return formatStringForAppTypePlural(message, dataFlowUnsupportedRegionsUsNat.map((region) => localizeRegionString(region)).join(', '));
    }
    if (isUsSecEnvironment()) {
        return formatStringForAppTypePlural(message, dataFlowUnsupportedRegionsUsSec.map((region) => localizeRegionString(region)).join(', '));
    }
    return formatStringForAppTypePlural(message, dataFlowUnsupportedRegionsPublic.map((region) => localizeRegionString(region)).join(', '));
}

export function dataFlowSupported(region: string, services: { exposureControlService: ExposureControlService }): boolean {
    if (__IS_A365__ || services.exposureControlService.enableADFSparkGateway) {
        return true;
    }

    return isDataFlowAdbRegion(region);
}

export function isDataFlowAdbRegion(region: string): boolean {
    return !(dataFlowUnsupportedRegionsPublic.includes(formatRegionString(region)) ||
        dataFlowUnsupportedRegionsFairfax.includes(formatRegionString(region)) ||
        dataFlowUnsupportedRegionsMooncake.includes(formatRegionString(region)) ||
        dataFlowUnsupportedRegionsUsNat.includes(formatRegionString(region)) ||
        dataFlowUnsupportedRegionsUsSec.includes(formatRegionString(region)));
}

export function localizeRegionString(region?: string): string {
    if (stringIsNullOrEmpty(region)) {
        return '---';
    }
    switch (formatRegionString(region)) {
        case regions.AutoResolve:
            return stringResources.Region_AutoResolve;
        case regions.AustraliaEast:
            return stringResources.Region_AustraliaEast;
        case regions.AustraliaSoutheast:
            return stringResources.Region_AustraliaSoutheast;
        case regions.BrazilSouth:
            return stringResources.Region_BrazilSouth;
        case regions.CanadaCentral:
            return stringResources.Region_CanadaCentral;
        case regions.CanadaEast:
            return stringResources.Region_CanadaEast;
        case regions.CentralIndia:
            return stringResources.Region_CentralIndia;
        case regions.CentralUS:
            return stringResources.Region_CentralUS;
        case regions.CentralUSEUAP:
            return stringResources.Region_CentralUSEUAP;
        case regions.EastAsia:
            return stringResources.Region_EastAsia;
        case regions.EastUS:
            return stringResources.Region_EastUS;
        case regions.EastUS2:
            return stringResources.Region_EastUS2;
        case regions.EastUS2EUAP:
            return stringResources.Region_EastUS2EUAP;
        case regions.FranceCentral:
            return stringResources.Region_FranceCentral;
        case regions.GermanyWestCentral:
            return stringResources.Region_GermanyWestCentral;
        case regions.JapanEast:
            return stringResources.Region_JapanEast;
        case regions.JapanWest:
            return stringResources.Region_JapanWest;
        case regions.JioIndiaWest:
            return stringResources.Region_JioIndiaWest;
        case regions.QatarCentral:
            return stringResources.Region_QatarCentral;
        case regions.KoreaCentral:
            return stringResources.Region_KoreaCentral;
        case regions.NorthCentralUS:
            return stringResources.Region_NorthCentralUS;
        case regions.NorthEurope:
            return stringResources.Region_NorthEurope;
        case regions.SouthCentralUS:
            return stringResources.Region_SouthCentralUS;
        case regions.SouthIndia:
            return stringResources.Region_SouthIndia;
        case regions.SoutheastAsia:
            return stringResources.Region_SoutheastAsia;
        case regions.UKSouth:
            return stringResources.Region_UKSouth;
        case regions.UKWest:
            return stringResources.Region_UKWest;
        case regions.WestCentralUS:
            return stringResources.Region_WestCentralUS;
        case regions.WestEurope:
            return stringResources.Region_WestEurope;
        case regions.WestIndia:
            return stringResources.Region_WestIndia;
        case regions.WestUS:
            return stringResources.Region_WestUS;
        case regions.WestUS2:
            return stringResources.Region_WestUS2;
        case regions.WestUS3:
            return stringResources.Region_WestUS3;
        case regions.SouthAfricaNorth:
            return stringResources.Region_SouthAfricaNorth;
        case regions.SouthAfricaWest:
            return stringResources.Region_SouthAfricaWest;
        case regions.SwitzerlandNorth:
            return stringResources.Region_SwitzerlandNorth;
        case regions.SwitzerlandWest:
            return stringResources.Region_SwitzerlandWest;
        case regions.SwedenCentral:
            return stringResources.Region_SwedenCentral;
        case regions.UAENorth:
            return stringResources.Region_UAENorth;
        case regions.NorwayEast:
            return stringResources.Region_NorwayEast;
        // Fairfax Regions
        case regions.USGovVirginia:
            return stringResources.Region_USGovVirginia;
        case regions.USGovArizona:
            return stringResources.Region_USGovArizona;
        case regions.USGovIowa:
            return stringResources.Region_USGovIowa;
        case regions.USGovTexas:
            return stringResources.Region_USGovTexas;
        case regions.USDoDCentral:
            return stringResources.Region_USDoDCentral;
        case regions.USDoDEast:
            return stringResources.Region_USDoDEast;
        // Mooncake Regions
        case regions.ChinaEast:
            return stringResources.Region_ChinaEast;
        case regions.ChinaEast2:
            return stringResources.Region_ChinaEast2;
        case regions.ChinaNorth:
            return stringResources.Region_ChinaNorth;
        case regions.ChinaNorth2:
            return stringResources.Region_ChinaNorth2;
        case regions.ChinaNorth3:
            return stringResources.Region_ChinaNorth3;
        // UsNat Regions
        case regions.UsNatEast:
            return stringResources.Region_UsNatEast;
        case regions.UsNatWest:
            return stringResources.Region_UsNatWest;
        // UsSec Regions
        case regions.UsSecEast:
            return stringResources.Region_UsSecEast;
        case regions.UsSecWest:
            return stringResources.Region_UsSecWest;
        // Bleu Regions
        case regions.BleuFranceCentral:
            return stringResources.Region_BleuFranceCentral;
        case regions.BleuFranceSouth:
            return stringResources.Region_BleuFranceSouth;
        // Delos Regions
        case regions.DelosCloudGermanyCentral:
            return stringResources.Region_DelosCloudGermanyCentral;
        case regions.DelosCloudGermanyNorth:
            return stringResources.Region_DelosCloudGermanyNorth;
        default:
            return region;
    }
}

export function formatRegionString(region: string): string {
    switch (formatStringForCompare(region)) {
        case formatStringForCompare(regions.AutoResolve):
            return regions.AutoResolve;
        case formatStringForCompare(regions.AustraliaEast):
            return regions.AustraliaEast;
        case formatStringForCompare(regions.AustraliaSoutheast):
            return regions.AustraliaSoutheast;
        case formatStringForCompare(regions.BrazilSouth):
            return regions.BrazilSouth;
        case formatStringForCompare(regions.CanadaCentral):
            return regions.CanadaCentral;
        case formatStringForCompare(regions.CanadaEast):
            return regions.CanadaEast;
        case formatStringForCompare(regions.CentralIndia):
            return regions.CentralIndia;
        case formatStringForCompare(regions.CentralUS):
            return regions.CentralUS;
        case formatStringForCompare(regions.CentralUSEUAP):
            return regions.CentralUSEUAP;
        case formatStringForCompare(regions.EastAsia):
            return regions.EastAsia;
        case formatStringForCompare(regions.EastUS):
            return regions.EastUS;
        case formatStringForCompare(regions.EastUS2):
            return regions.EastUS2;
        case formatStringForCompare(regions.EastUS2EUAP):
            return regions.EastUS2EUAP;
        case formatStringForCompare(regions.FranceCentral):
            return regions.FranceCentral;
        case formatStringForCompare(regions.GermanyWestCentral):
            return regions.GermanyWestCentral;
        case formatStringForCompare(regions.JapanEast):
            return regions.JapanEast;
        case formatStringForCompare(regions.JapanWest):
            return regions.JapanWest;
        case formatStringForCompare(regions.JioIndiaWest):
            return regions.JioIndiaWest;
        case formatStringForCompare(regions.QatarCentral):
            return regions.QatarCentral;
        case formatStringForCompare(regions.KoreaCentral):
            return regions.KoreaCentral;
        case formatStringForCompare(regions.NorthCentralUS):
            return regions.NorthCentralUS;
        case formatStringForCompare(regions.NorthEurope):
            return regions.NorthEurope;
        case formatStringForCompare(regions.SouthCentralUS):
            return regions.SouthCentralUS;
        case formatStringForCompare(regions.SouthIndia):
            return regions.SouthIndia;
        case formatStringForCompare(regions.SoutheastAsia):
            return regions.SoutheastAsia;
        case formatStringForCompare(regions.UKSouth):
            return regions.UKSouth;
        case formatStringForCompare(regions.UKWest):
            return regions.UKWest;
        case formatStringForCompare(regions.WestCentralUS):
            return regions.WestCentralUS;
        case formatStringForCompare(regions.WestEurope):
            return regions.WestEurope;
        case formatStringForCompare(regions.WestIndia):
            return regions.WestIndia;
        case formatStringForCompare(regions.WestUS):
            return regions.WestUS;
        case formatStringForCompare(regions.WestUS2):
            return regions.WestUS2;
        case formatStringForCompare(regions.WestUS3):
            return regions.WestUS3;
        case formatStringForCompare(regions.SouthAfricaNorth):
            return regions.SouthAfricaNorth;
        case formatStringForCompare(regions.SouthAfricaWest):
            return regions.SouthAfricaWest;
        case formatStringForCompare(regions.SwitzerlandNorth):
            return regions.SwitzerlandNorth;
        case formatStringForCompare(regions.SwitzerlandWest):
            return regions.SwitzerlandWest;
        case formatStringForCompare(regions.SwedenCentral):
            return regions.SwedenCentral;
        case formatStringForCompare(regions.NorwayEast):
            return regions.NorwayEast;
        case formatStringForCompare(regions.UAENorth):
            return regions.UAENorth;
        case formatStringForCompare(regions.USGovArizona):
            return regions.USGovArizona;
        case formatStringForCompare(regions.USGovVirginia):
            return regions.USGovVirginia;
        case formatStringForCompare(regions.USGovIowa):
            return regions.USGovIowa;
        case formatStringForCompare(regions.USGovTexas):
            return regions.USGovTexas;
        case formatStringForCompare(regions.USDoDCentral):
            return regions.USDoDCentral;
        case formatStringForCompare(regions.USDoDEast):
            return regions.USDoDEast;
        case formatStringForCompare(regions.ChinaEast):
            return regions.ChinaEast;
        case formatStringForCompare(regions.ChinaEast2):
            return regions.ChinaEast2;
        case formatStringForCompare(regions.ChinaNorth):
            return regions.ChinaNorth;
        case formatStringForCompare(regions.ChinaNorth2):
            return regions.ChinaNorth2;
        case formatStringForCompare(regions.ChinaNorth3):
            return regions.ChinaNorth3;
        case formatStringForCompare(regions.UsNatEast):
            return regions.UsNatEast;
        case formatStringForCompare(regions.UsNatWest):
            return regions.UsNatWest;
        case formatStringForCompare(regions.UsSecEast):
            return regions.UsSecEast;
        case formatStringForCompare(regions.UsSecWest):
            return regions.UsSecWest;
        case formatStringForCompare(regions.BleuFranceCentral):
            return regions.BleuFranceCentral;
        case formatStringForCompare(regions.BleuFranceSouth):
            return regions.BleuFranceSouth;
        case formatStringForCompare(regions.DelosCloudGermanyCentral):
            return regions.DelosCloudGermanyCentral;
        case formatStringForCompare(regions.DelosCloudGermanyNorth):
            return regions.DelosCloudGermanyNorth;
        default:
            return region;
    }
}

export class RegionConst {
    public static get pqRegionOptions(): Array<ISelectOption<string>> {
        if (isFairfaxEnvironment()) {
            // FairFax Prod
            return [
                {
                    label: stringResources.Region_USGovVirginia,
                    value: regions.USGovVirginia
                },
                {
                    label: stringResources.Region_USGovArizona,
                    value: regions.USGovArizona
                }
            ];
        }
        if (isMooncakeEnvironment()) {
            // Mooncake Prod
            return [
                {
                    label: stringResources.Region_ChinaEast2,
                    value: regions.ChinaEast2
                },
                {
                    label: stringResources.Region_ChinaNorth2,
                    value: regions.ChinaNorth2
                }
            ];
        }
        if (isUsNatEnvironment()) {
            // UsNat Prod
            return [
                {
                    label: stringResources.Region_UsNatEast,
                    value: regions.UsNatEast
                },
                {
                    label: stringResources.Region_UsNatWest,
                    value: regions.UsNatWest
                }
            ];
        }
        if (isUsSecEnvironment()) {
            // UsSec Prod
            return [
                {
                    label: stringResources.Region_UsSecEast,
                    value: regions.UsSecEast
                },
                {
                    label: stringResources.Region_UsSecWest,
                    value: regions.UsSecWest
                }
            ];
        }
        if (isBleuEnvironment()) {
            // Bleu Prod
            return [
                {
                    label: stringResources.Region_BleuFranceCentral,
                    value: regions.BleuFranceCentral
                },
                {
                    label: stringResources.Region_BleuFranceSouth,
                    value: regions.BleuFranceSouth
                }
            ];
        }
        if (isDelosEnvironment()) {
            // Delos Prod
            return [
                {
                    label: stringResources.Region_DelosCloudGermanyCentral,
                    value: regions.DelosCloudGermanyCentral
                },
                {
                    label: stringResources.Region_DelosCloudGermanyNorth,
                    value: regions.DelosCloudGermanyNorth
                }
            ];
        } else {
            // Public Azure Prod
            return [
                {
                    label: stringResources.Region_AustraliaEast,
                    value: formatStringForCompare(regions.AustraliaEast)
                }, {
                    label: stringResources.Region_AustraliaSoutheast,
                    value: formatStringForCompare(regions.AustraliaSoutheast)
                }, {
                    label: stringResources.Region_BrazilSouth,
                    value: formatStringForCompare(regions.BrazilSouth)
                }, {
                    label: stringResources.Region_CanadaCentral,
                    value: formatStringForCompare(regions.CanadaCentral)
                }, {
                    label: stringResources.Region_CanadaEast,
                    value: formatStringForCompare(regions.CanadaEast)
                }, {
                    label: stringResources.Region_CentralIndia,
                    value: formatStringForCompare(regions.CentralIndia)
                }, {
                    label: stringResources.Region_CentralUS,
                    value: formatStringForCompare(regions.CentralUS)
                }, {
                    label: stringResources.Region_EastAsia,
                    value: formatStringForCompare(regions.EastAsia)
                }, {
                    label: stringResources.Region_EastUS,
                    value: formatStringForCompare(regions.EastUS)
                }, {
                    label: stringResources.Region_EastUS2,
                    value: formatStringForCompare(regions.EastUS2)
                }, {
                    label: stringResources.Region_FranceCentral,
                    value: formatStringForCompare(regions.FranceCentral)
                }, {
                    label: stringResources.Region_JapanEast,
                    value: formatStringForCompare(regions.JapanEast)
                }, {
                    label: stringResources.Region_JapanWest,
                    value: formatStringForCompare(regions.JapanWest)
                }, {
                    label: stringResources.Region_KoreaCentral,
                    value: formatStringForCompare(regions.KoreaCentral)
                }, {
                    label: stringResources.Region_NorthEurope,
                    value: formatStringForCompare(regions.NorthEurope)
                }, {
                    label: stringResources.Region_SouthAfricaNorth,
                    value: formatStringForCompare(regions.SouthAfricaNorth)
                }, {
                    label: stringResources.Region_SouthCentralUS,
                    value: formatStringForCompare(regions.SouthCentralUS)
                }, {
                    label: stringResources.Region_SoutheastAsia,
                    value: formatStringForCompare(regions.SoutheastAsia)
                }, {
                    label: stringResources.Region_SouthIndia,
                    value: formatStringForCompare(regions.SouthIndia)
                }, {
                    label: stringResources.Region_SwitzerlandNorth,
                    value: formatStringForCompare(regions.SwitzerlandNorth)
                }, {
                    label: stringResources.Region_UKSouth,
                    value: formatStringForCompare(regions.UKSouth)
                }, {
                    label: stringResources.Region_UKWest,
                    value: formatStringForCompare(regions.UKWest)
                }, {
                    label: stringResources.Region_WestEurope,
                    value: formatStringForCompare(regions.WestEurope)
                }, {
                    label: stringResources.Region_WestUS,
                    value: formatStringForCompare(regions.WestUS)
                }, {
                    label: stringResources.Region_WestUS2,
                    value: formatStringForCompare(regions.WestUS2)
                }
            ];
        }
    }

    public static get newDataFactoryOptions(): Array<ISelectOption<string>> {
        if (isFairfaxEnvironment()) {
            // FairFax Prod
            return [
                {
                    label: stringResources.Region_USGovVirginia,
                    value: regions.USGovVirginia
                },
                {
                    label: stringResources.Region_USGovArizona,
                    value: regions.USGovArizona
                }
            ];
        }
        if (isMooncakeEnvironment()) {
            // Mooncake Prod
            return [
                {
                    label: stringResources.Region_ChinaEast2,
                    value: regions.ChinaEast2
                },
                {
                    label: stringResources.Region_ChinaNorth2,
                    value: regions.ChinaNorth2
                },
                {
                    label: stringResources.Region_ChinaNorth3,
                    value: regions.ChinaNorth3
                }
            ];
        }
        if (isUsNatEnvironment()) {
            // UsNat Prod
            return [
                {
                    label: stringResources.Region_UsNatEast,
                    value: regions.UsNatEast
                },
                {
                    label: stringResources.Region_UsNatWest,
                    value: regions.UsNatWest
                }
            ];
        }
        if (isUsSecEnvironment()) {
            // UsSec Prod
            return [
                {
                    label: stringResources.Region_UsSecEast,
                    value: regions.UsSecEast
                },
                {
                    label: stringResources.Region_UsSecWest,
                    value: regions.UsSecWest
                }
            ];
        }
        if (isBleuEnvironment()) {
            // Bleu Prod
            return [
                {
                    label: stringResources.Region_BleuFranceCentral,
                    value: regions.BleuFranceCentral
                },
                {
                    label: stringResources.Region_BleuFranceSouth,
                    value: regions.BleuFranceSouth
                }
            ];
        }
        if (isDelosEnvironment()) {
            // Delos Prod
            return [
                {
                    label: stringResources.Region_DelosCloudGermanyCentral,
                    value: regions.DelosCloudGermanyCentral
                },
                {
                    label: stringResources.Region_DelosCloudGermanyNorth,
                    value: regions.DelosCloudGermanyNorth
                }
            ];
        } else {
            // Public Azure Prod
            return [
                {
                    label: stringResources.Region_AustraliaEast,
                    value: formatStringForCompare(regions.AustraliaEast)
                }, {
                    label: stringResources.Region_AustraliaSoutheast,
                    value: formatStringForCompare(regions.AustraliaSoutheast)
                }, {
                    label: stringResources.Region_BrazilSouth,
                    value: formatStringForCompare(regions.BrazilSouth)
                }, {
                    label: stringResources.Region_CanadaCentral,
                    value: formatStringForCompare(regions.CanadaCentral)
                }, {
                    label: stringResources.Region_CanadaEast,
                    value: formatStringForCompare(regions.CanadaEast)
                }, {
                    label: stringResources.Region_CentralIndia,
                    value: formatStringForCompare(regions.CentralIndia)
                }, {
                    label: stringResources.Region_CentralUS,
                    value: formatStringForCompare(regions.CentralUS)
                }, {
                    label: stringResources.Region_EastAsia,
                    value: formatStringForCompare(regions.EastAsia)
                }, {
                    label: stringResources.Region_EastUS,
                    value: formatStringForCompare(regions.EastUS)
                }, {
                    label: stringResources.Region_EastUS2,
                    value: formatStringForCompare(regions.EastUS2)
                }, {
                    label: stringResources.Region_FranceCentral,
                    value: formatStringForCompare(regions.FranceCentral)
                }, {
                    label: stringResources.Region_GermanyWestCentral,
                    value: formatStringForCompare(regions.GermanyWestCentral)
                }, {
                    label: stringResources.Region_JapanEast,
                    value: formatStringForCompare(regions.JapanEast)
                }, {
                    label: stringResources.Region_JapanWest,
                    value: formatStringForCompare(regions.JapanWest)
                }, {
                    label: stringResources.Region_KoreaCentral,
                    value: formatStringForCompare(regions.KoreaCentral)
                }, {
                    label: stringResources.Region_NorwayEast,
                    value: formatStringForCompare(regions.NorwayEast)
                }, {
                    label: stringResources.Region_NorthCentralUS,
                    value: formatStringForCompare(regions.NorthCentralUS)
                }, {
                    label: stringResources.Region_NorthEurope,
                    value: formatStringForCompare(regions.NorthEurope)
                }, {
                    label: stringResources.Region_QatarCentral,
                    value: formatStringForCompare(regions.QatarCentral)
                }, {
                    label: stringResources.Region_SouthAfricaNorth,
                    value: formatStringForCompare(regions.SouthAfricaNorth)
                }, {
                    label: stringResources.Region_SouthCentralUS,
                    value: formatStringForCompare(regions.SouthCentralUS)
                }, {
                    label: stringResources.Region_SoutheastAsia,
                    value: formatStringForCompare(regions.SoutheastAsia)
                }, {
                    label: stringResources.Region_SouthIndia,
                    value: formatStringForCompare(regions.SouthIndia)
                }, {
                    label: stringResources.Region_SwitzerlandNorth,
                    value: formatStringForCompare(regions.SwitzerlandNorth)
                }, {
                    label: stringResources.Region_SwitzerlandWest,
                    value: formatStringForCompare(regions.SwitzerlandWest)
                }, {
                    label: stringResources.Region_UAENorth,
                    value: formatStringForCompare(regions.UAENorth)
                }, {
                    label: stringResources.Region_UKSouth,
                    value: formatStringForCompare(regions.UKSouth)
                }, {
                    label: stringResources.Region_UKWest,
                    value: formatStringForCompare(regions.UKWest)
                }, {
                    label: stringResources.Region_WestEurope,
                    value: formatStringForCompare(regions.WestEurope)
                }, {
                    label: stringResources.Region_WestCentralUS,
                    value: formatStringForCompare(regions.WestCentralUS)
                }, {
                    label: stringResources.Region_WestUS,
                    value: formatStringForCompare(regions.WestUS)
                }, {
                    label: stringResources.Region_WestUS2,
                    value: formatStringForCompare(regions.WestUS2)
                }, {
                    label: stringResources.Region_WestUS3,
                    value: formatStringForCompare(regions.WestUS3)
                }
            ];
        }
    }
}
